import Token from '@/di/di.token'

import useService from './useService'

export default function useRoomService() {
  const { service } = useService(Token.ROOM_SERVICE)
  return { service }
}
